import { get, patch, post } from "./apiService";

class CalculatorService {

    /**
     * Fetch all the available calculators 
     * @param {boolean} isActive 
     * @returns  {Promise<Object>} Calculator data
     */

    async getAllCalculators(options = {}) {
        try {
            const {
                isActive,
                top,
                skip,
                filter,
                orderby,
                orderbydirection
            } = options;

            const params = new URLSearchParams();

            if (typeof isActive !== "undefined") params.append("isActive", isActive);
            if (top) params.append("$top", top);
            if (skip) params.append("$skip", skip);
            if (filter) params.append("$filter", filter);
            if (orderby) params.append("$orderby", orderby);
            if (orderbydirection) params.append("$orderbydirection", orderbydirection);

            const queryString = params.toString();
            return await get(`calculators?${queryString}`);
        } catch (error) {
            console.error("Failed to fetch Calculators", error);
            throw error;
        }
    }


    /**
 * Fetch all calculator categories
 * @returns {Promise<Array>} List of categories
 */
    async getAllCategories() {
        try {
            return await get("calculators/categories");
        } catch (error) {
            console.error("Failed to fetch categories", error);
            throw error;
        }
    }

    /**
 * Update a calculator
 * Only sends the fields that are provided (isActive, categoryId)
 * @param {string} calculatorId
 * @param {Object} payload
 * @param {boolean} [payload.isActive]
 * @param {string} [payload.categoryId]
 * @returns {Promise<Object>} Updated calculator
 */
    async updateCalculator(calculatorId, payload = {}) {
        try {
            const body = {};

            if (typeof payload.isActive !== "undefined") body.isActive = payload.isActive;
            if (payload.categoryId) body.categoryId = payload.categoryId;

            if (Object.keys(body).length === 0) {
                throw new Error("Nothing to update. Provide at least one field.");
            }
            return await patch(`calculators/${calculatorId}`, body);
        } catch (error) {
            console.error(`Failed to update calculator ${calculatorId}`, error);
            throw error;
        }
    }

    /**
    * Upload or update a calculator icon
    * Endpoint: /calculators/{calculatorId}/icon
    * Expects a PNG file in multipart/form-data
    * @param {string} calculatorId
    * @param {File} file
    * @returns {Promise<Object>} Response containing updated calculator or icon URL
    */
    async uploadCalculatorIcon(calculatorId, file) {
        try {
            const formData = new FormData();
            formData.append("file", file);

            return await post(`calculators/${calculatorId}/icon`, formData);
        } catch (error) {
            console.error(`Failed to upload icon for calculator ${calculatorId}`, error);
            throw error;
        }
    }
}
export default new CalculatorService();